import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getShareableCalendarViews as getShareableCalendarViewsApi} from '../../../services/shareableCalendarViews'

export async function getShareableCalendarViews(dispatch, user_id) {
  try {
    dispatch({type: PENDING})
    let response = await getShareableCalendarViewsApi(user_id)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Create Calendar View Failed: ${user_id}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
